<template>
  <div id="index">

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchObj">
        <el-form-item label="标题/品牌">
          <el-input v-model="searchObj.search" placeholder="请输入标题/品牌"></el-input>
        </el-form-item>
        <el-form-item label="会员信息">
          <el-input v-model="searchObj.user_search" placeholder="请输入昵称丨手机号丨ID"></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机号">
          <el-input v-model="searchObj.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item> -->
        <el-form-item label="分类">
          <el-select v-model="searchObj.category_id" placeholder="请选择分类">
            <el-option value="" label="全部"></el-option>
            <el-option v-for="item in cateList" :key="item.id" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchObj.status" placeholder="请选择状态">
            <el-option value="" label="全部"></el-option>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市">
          <el-select v-model="searchObj.city_id" placeholder="请选择城市">
            <el-option value="" label="全部"></el-option>
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.city_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!-- <div class="common-level-rail">
      <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/appraisal/appraisal/add'">添加成色</el-button>
    </div> -->

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="list">
          <el-table-column  label="用户" width="260">
            <template slot-scope="scope">
              <div class="userInfo">
                <img :src="scope.row.user.avatarUrl" alt="">
                <div class="main">
                  <p class="name">{{ scope.row.user.nickName }}</p>
                  <p class="text">{{ scope.row.user.mobile }}</p>
                  <p class="text">ID:{{ scope.row.user.user_id }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="资产" width="260">
            <template slot-scope="scope">
              <div class="userInfo">
                <img :src="scope.row.images[0].file_path" alt="">
                <div class="main">
                  <p class="name">{{ scope.row.title }}</p>
                  <p class="text red">￥{{ scope.row.price }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="title" label="标题"></el-table-column> -->
          <el-table-column prop="category.name" label="分类"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="fineness.name" label="成色"></el-table-column>
          <el-table-column label="附件">
            <template slot-scope="scope">
              {{scope.row.attachment.map(item=>item.name).join('、')}}
            </template>
          </el-table-column>
          <el-table-column prop="city.name" label="城市"></el-table-column>
          <!-- <el-table-column prop="price" label="价格"></el-table-column> -->
          <el-table-column prop="delivery.name" label="配送方式">
            <template slot-scope="scope">
              {{ deliveryList.find(item=>item.value==scope.row.delivery_type).label }}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag size="small" :type="statusList.find(item=>item.value==scope.row.status).type">{{ statusList.find(item=>item.value==scope.row.status).label }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200px">
            <template slot-scope="scope">
              <el-button @click="$refs.detail.show(scope.row,'detail')" type="text" size="small" v-auth="'/secondhand/product/detail'">详情</el-button>
              <el-button v-if="scope.row.status=='10'" @click="$refs.detail.show(scope.row,'result')" type="text" size="small" v-auth="'/secondhand/product/audit'">审核</el-button>
              <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/secondhand/product/edit'">编辑</el-button>
              <el-button @click="deleteItem(scope.row)" type="text" size="small" v-auth="'/secondhand/product/delete'">删除</el-button>
              <el-button v-if="scope.row.status==20||scope.row.status==30"  @click="changeStatus(scope.row)" type="text" size="small" v-auth="'/secondhand/product/status'">{{ scope.row.status=='20'?'下架':'上架' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>


    <Detail ref="detail" :statusList="statusList" :deliveryList="deliveryList" @refresh="getData"></Detail>


    <AddEdit ref="addEdit" :cateList="cateList" :finenessList="finenessList" :cityList="cityList" :attachmentList="attachmentList" @refresh="getData"></AddEdit>

  </div>
  </template>

  <script>
  import Detail from './detail.vue';
  import AddEdit from './addEdit.vue';
  import SecondhandApi from '@/api/secondhand'
  import {
    MAIN_KEY,
    fetchLabelValueOptions,
    fetchTaggedOptionsMerge,
    FALLBACK_SECONDHAND_DELIVERY,
    FALLBACK_SECONDHAND_PRODUCT_STATUS,
  } from '@/utils/sysEnumOptions'
  export default {
    components:{Detail,AddEdit},
    data() {
      return {
        searchObj:{
          page:1,
          list_rows:10,
          search:'',
          user_search:'',
          // mobile:'',
          category_id:'',
          city_id:'',
          status:'',
        },
        list: [],
        total:0,
        cateList:[],
        cityList:[],
        attachmentList:[],
        finenessList:[],
        deliveryList: [...FALLBACK_SECONDHAND_DELIVERY],
        // 10审核、20上架、30下架
        statusList: [...FALLBACK_SECONDHAND_PRODUCT_STATUS],
      }
    },
    created(){
      Promise.all([
        fetchLabelValueOptions(MAIN_KEY.secondhandDeliveryType, { numberValue: true }, FALLBACK_SECONDHAND_DELIVERY),
        fetchTaggedOptionsMerge(MAIN_KEY.secondhandProductStatus, FALLBACK_SECONDHAND_PRODUCT_STATUS),
      ]).then(([dl, sl]) => {
        this.deliveryList = dl
        this.statusList = sl
      }).catch(() => {})
      this.getData()
      this.getCateList()
      this.getCityList()
      this.getFinenessList()
      this.getAttachmentList()
    },
    methods:{

      getData(){
        SecondhandApi.secondhandIndex(this.searchObj).then(result=>{
          let list=result.data.list
          this.list=list.data
          this.total=list.total
        })
      },

      // 获取品类列表
      getCateList(){
        SecondhandApi.categoryAll().then(result=>{
          let list=result.data.category
          this.cateList=list
        })
      },

      // 获取城市列表
      getCityList(){
        SecondhandApi.cityAll().then(result=>{
          let list=result.data.list
          this.cityList=list
        })
      },

      // 获取成色列表
      getFinenessList(){
        SecondhandApi.finenessAll().then(result=>{
          let list=result.data.category
          this.finenessList=list
        })
      },

      // 获取附件列表
      getAttachmentList(){
        SecondhandApi.attachmentAll().then(result=>{
          let list=result.data.category
          this.attachmentList=list
        })
      },

      // 删除
      deleteItem(e){
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          SecondhandApi.secondhandDelete({product_id:e.product_id}).then(result => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getData()
          })
        })
      },

      // 上下架
      changeStatus(e){
        this.$confirm('确定'+(e.status=='20'?'下架':'上架')+'吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          SecondhandApi.secondhandStatus({product_id:e.product_id,status:e.status=='20'?'30':'20'}).then(result => {
            this.$message({
              message: (e.status=='20'?'下架':'上架')+'成功',
              type: 'success'
            })
            this.getData()
          })
        })
      },



      // 分页
      pageChange(e){
        this.searchObj.page=e
        this.getData()
      },

    }
  }
  </script>

  <style lang="scss" scoped>
  .userInfo{display: flex;
    img{width: 60px;height: 60px;}
    .main{flex: 1;padding-left: 10px;
      .name{font-size: 12px;font-weight: bold;}
       .text{color:#666;}
      .red{color: #ff0000;}
    }
  }
  </style>



// WEBPACK FOOTER //
// src/views/secondhand/product/index.vue